import "../../styles/ReusableStyles/SubscribeButton.css";

const SubscribeButton = ({ text, onClick, disabled }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <button
      className={`subscribe-button ${disabled ? 'disabled' : ''}`}
      data-text={text}
      onClick={handleClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default SubscribeButton;
